/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { setParallaxMainVisual } from "./scrollTrigger/scrollTrigger-parallax";
import {
  actionToSplashHome,
  hintBrowser,
} from "./scrollTrigger/scrollTrigger-splash";
import { setTrigger } from "./scrollTrigger/scrollTrigger-trigger";

/**
 * scrollTrigger
 */
const setScrollTrigger = () => {
  setParallaxMainVisual();
  setTrigger();
};

/**
 * スプラッシュ
 */
const setSplash = () => {
  setTimeout(() => {
    actionToSplashHome();
    hintBrowser();
  }, 1000);
};

window.addEventListener("DOMContentLoaded", setSplash);

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setScrollTrigger, setSplash };
